module.exports = __webpack_public_path__ + "static/media/bts_carassauga_180526_002_small.e6be4c28.jpg";